module.exports = __webpack_public_path__ + "img/settings.4f2a618f.svg";